<div class="column" [class.column-sm]="static" [class.with-filter]="column.filter">
  <div class="title" [title]="column.title">{{ column.title }}</div>
  <ng-template *ngIf="column.filter" ccFormRegisterViewFilterHost [filter]="column.filter"></ng-template>
</div>
